import React from "react";
import "./ProjectGrace.scss";
import GenericHero from "../../components/GenericHero/GenericHero";
import graceImg from "../../assets/images/mockupGrace.png";
import Carousel from "../../components/Carousel/Carousel";
import { graceCarouselContents } from "./graceCarouselContents";
import Heading from "../../components/Heading/Heading";
import reactLogo from "../../assets/icons/react.svg";
import sassLogo from "../../assets/icons/sass.svg";
import typeLogo from "../../assets/icons/typescript.svg";
import axiosLogo from "../../assets/icons/axios.svg";
import netlifyLogo from "../../assets/icons/netlify.svg";
import nodeLogo from "../../assets/icons/nodejs.svg";
import exLogo from "../../assets/icons/express.svg";
import mailgunLogo from "../../assets/icons/mailgun.svg";
import gcsLogo from "../../assets/icons/gcs.svg";
import herokuLogo from "../../assets/icons/heroku.svg";

export default function ProjectGrace() {
  return (
    <div className="gracePage">
      <GenericHero
        head="More of Grace"
        text="A dynamic redesign featuring a user-friendly sermon archive,
          announcement carousel, and secure admin tools. Built with TypeScript
          and Google Cloud integrations, this site serves as a welcoming first
          point of contact for new visitors."
        hImg={graceImg}
        hAlt="A mockup of several pages from moreofgrace.org"
        btnContent="Read More"
        btnLink="#graceDetails"
        btn2Content="Visit Website"
        btn2Link="http://moreofgrace.org"
      />
      <section className="gracePage__details" id="graceDetails">
        <Heading content="Details" />
        <div className="gracePage__container">
          <section className="gracePage__content">
            <p className="gracePage__desc">
              This project started when the pastor reached out for a redesign of
              their website, with the goal of better engaging visitors and
              encouraging them to visit the church in person. Working closely
              with the pastor through many iterations, we landed on a design
              language that reflects the church's timeless character while
              remaining user-friendly and modern.
            </p>
            <p className="gracePage__desc">
              The result is a carefully developed site that serves as a
              welcoming first contact point for visitors, encouraging them to
              learn more about the church. Beyond providing information about
              the church, staff, and what to expect when attending, the website
              features a user-friendly sermon archive. This archive offers
              first-time guests a glimpse into what a typical service is like
              through weekly video uploads, while also allowing current members
              to revisit and study past sermons.
            </p>
            <p className="gracePage__desc">
              To meet the church's specific needs, I developed an admin suite of
              tools to intuitively and securely manage sermons and
              announcements. This includes features for adding, editing, and
              organizing sermon data, which is all stored in Google Cloud
              Storage behind a secure login system.
            </p>
          </section>
          <Carousel items={graceCarouselContents} />
        </div>
      </section>
      <section className="techstack">
        <Heading content="Tech Stack" />
        <div className="techstack__front">
          <p className="techstack__title">Front End</p>
          <ul className="techstack__list">
            <li className="techstack__item">
              <img
                src={reactLogo}
                alt="React Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">React</p>
            </li>
            <li className="techstack__item">
              <img
                src={sassLogo}
                alt="SASS/SCSS Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">SASS/SCSS</p>
            </li>
            <li className="techstack__item">
              <img
                src={typeLogo}
                alt="TypeScript Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">TypeScript</p>
            </li>
            <li className="techstack__item">
              <img
                src={axiosLogo}
                alt="Axios Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Axios</p>
            </li>
            <li className="techstack__item">
              <img
                src={netlifyLogo}
                alt="Netlify Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Netlify</p>
            </li>
          </ul>
        </div>
        <div className="techstack__back">
          <p className="techstack__title">Back End</p>
          <ul className="techstack__list">
            <li className="techstack__item">
              <img
                src={nodeLogo}
                alt="Node.js Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Node.js</p>
            </li>
            <li className="techstack__item">
              <img
                src={exLogo}
                alt="Express.js Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Express.js</p>
            </li>
            <li className="techstack__item">
              <img
                src={mailgunLogo}
                alt="MailGun.js Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">MailGun.js</p>
            </li>
            <li className="techstack__item">
              <img
                src={gcsLogo}
                alt="Google Cloud Storage Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Google Cloud Storage</p>
            </li>
            <li className="techstack__item">
              <img
                src={herokuLogo}
                alt="Heroku Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Heroku</p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
